import React, { useState, useEffect } from "react";
import HeaderHero from "./HeaderHero";
import "./ConfirmationPage.scss";
import EnrollmentConfirmation from "./EnrollmentConfirmation";
import { useNavigate } from "react-router-dom";
import SelectionSummary from "./SelectionSummary";
import DealerInformation from "./DealerInformation";

function ConfirmationPage() {
	const navigate = useNavigate();
	const [selections, setSelections] = useState({
		agency: "",
		package: "",
	});

	const [dealerInfo, setDealerInfo] = useState({
		dealerCode: "",
		dealershipName: "",
		dealershipContact: { first: "", last: "" },
		emailAddress: "",
		phoneNumber: { full: "" },
	});

	useEffect(() => {
		const savedSelections = localStorage.getItem("enrollmentSelections");
		const savedDealerInfo = localStorage.getItem("dealerInfo");

		if (savedSelections) {
			setSelections(JSON.parse(savedSelections));
		}
		if (savedDealerInfo) {
			setDealerInfo(JSON.parse(savedDealerInfo));
		}

		// Clean up localStorage when component unmounts
		return () => {
			localStorage.removeItem("enrollmentSelections");
			localStorage.removeItem("dealerInfo");
		};
	}, []);

	return (
		<>
			<div>
				<HeaderHero
					title="ENROLLMENT CONFIRMATION"
					subtitle=""
					disclaimer=""
				/>

				<div className="confirmation-page">
					<EnrollmentConfirmation agency={selections.agency} />

					<div className="confirmation-page-content">
						<div className="confirmation-page-content-left">
							<DealerInformation dealerInfo={dealerInfo} />
							<div className="back-button-container">
								<button
									className="back-button"
									onClick={() => navigate("/")}>
									Back to Homepage
								</button>
							</div>
						</div>
						<SelectionSummary
							selections={selections}
							showCount={false}
							showReimbursement={false}
						/>
					</div>
				</div>
			</div>
		</>
	);
}

export default ConfirmationPage;
